define('container/argResolvers/QueryArgResolver',[],function() {

    'use strict';

    function QueryArgResolver(queryConstructorServiceId) {
        this.queryConstructorServiceId = queryConstructorServiceId;
    }

    QueryArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substring(0, 5) === 'Query';
    };

    QueryArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {

        var parts = argDefinition.split(':'),
            factoryMethod = '';

        switch (parts[1]) {
            case 'common': factoryMethod = 'fromRelativeCommonPath'; break;
            case 'game-browser': factoryMethod = 'fromRelativeGameBrowserPath'; break;
            default: factoryMethod = 'fromRelativePath';
        }

        return extensionApi.container.get(this.queryConstructorServiceId).then(function(Query) {
            return Query[factoryMethod](parts[2]);
        });
    };

    return QueryArgResolver;
});

